export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter"])}
      },
      "en": {
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])}
      }
    }
  })
}
